import { Receipt, CheckCircle2 } from "lucide-react";

function describe(t) {
  if (t.metadata?.type === "subscription") {
    return `${t.metadata?.plan_id} plan (${t.metadata?.billing_cycle})`;
  }
  return (t.metadata?.addon_id || "").replace(/_/g, " ");
}

export default function BillingHistory({ history }) {
  return (
    <div className="mt-6 rounded-xl border border-slate-200 bg-white overflow-hidden">
      <div className="px-6 py-4 border-b border-slate-100 flex items-center gap-2">
        <Receipt size={18} className="text-slate-400" />
        <h3 className="font-heading font-bold text-[#0A0F1C]">Billing history</h3>
      </div>
      {history.length === 0 ? (
        <div className="px-6 py-10 text-center text-sm text-slate-400" data-testid="billing-history-empty">No payments yet.</div>
      ) : (
        <table className="w-full text-sm" data-testid="billing-history-table">
          <thead>
            <tr className="text-left text-xs uppercase tracking-wider text-slate-400 border-b border-slate-100">
              <th className="px-6 py-3 font-semibold">Date</th>
              <th className="px-6 py-3 font-semibold">Description</th>
              <th className="px-6 py-3 font-semibold text-right">Amount</th>
              <th className="px-6 py-3 font-semibold text-right">Status</th>
            </tr>
          </thead>
          <tbody>
            {history.map((t) => (
              <tr key={t.session_id} className="border-b border-slate-50 last:border-0">
                <td className="px-6 py-3 font-mono text-slate-600">{(t.created_at || "").slice(0, 10)}</td>
                <td className="px-6 py-3 text-slate-700 capitalize">{describe(t)}</td>
                <td className="px-6 py-3 text-right font-mono text-[#0A0F1C]">${t.amount?.toFixed(2)}</td>
                <td className="px-6 py-3 text-right">
                  <span className="inline-flex items-center gap-1 text-green-600 text-xs font-medium"><CheckCircle2 size={13} /> Paid</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
